module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "girl1"
    }
  }, [_c('path', {
    attrs: {
      "id": "girl1_hair",
      "fill": "#91713D",
      "d": "M1014.12 268.58c-16.77-1.14-24.5 3.22-24.68 21.7-1.9 1.08-5.48 3.17-5.7 8.22-.2 5.05 3.12 6.66 3.33 7.24.2.57-1.23 5.4 3.32 8.2 7.92 4.86 20.4-1.86 21.35-1.93.94-.06 4.86 3.58 13.3 1.94 5.5-1.08 10-9 1.4-16.9 1.5-6.52-2-27.76-12.33-28.46z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl1_bag_3",
      "width": "27.52",
      "height": "38.61",
      "x": "989.73",
      "y": "310.47",
      "fill": "#FBD79E",
      "transform": "matrix(-1 0 0 1 2006.985 0)",
      "rx": "13.76"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_right_hand",
      "fill": "#BC9555",
      "d": "M1030.2 367.05c.2 1.05 1.02 1.5 1.92 2.62 1.06 1.3 1.47 3.93 2.75 5.96-.15.56-1.82-.1-2.3-.93-.46-.83-.83-1.5-.98-1.7-.16-.2-.42-.14-.46.08-.04.23 1.23 7.96 1.14 8.37-.1.4-1 .6-1.23.25-.23-.36-1.38-6.45-1.48-6.6-.1-.15-.3-.03-.36.07s1.33 6.57 1.24 6.84c-.1.28-1.04.42-1.18.24-.14-.18-1.4-6.65-1.54-6.78-.13-.12-.34-.07-.4.08-.06.15 1.37 6.34 1.28 6.64-.1.3-1 .48-1.14.22-.14-.25-1.53-6.5-1.64-6.56-.1-.08-.22-.05-.3.05-.06.1.75 4.8.66 5.08-.1.28-.78.48-.94.18-.16-.3-1.87-11.8-2-12.45-.45-2.1.32-4.53 2.7-5 2.4-.47 3.8 1.08 4.26 3.35z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_right_arm_bottom",
      "fill": "#BC9555",
      "d": "M1022.67 340.95c-1.94.3-3.27 2.17-2.96 4.14l4.2 26.9c.3 1.98 2.13 3.33 4.08 3 1.94-.3 3.26-2.15 2.96-4.13l-4.2-26.9c-.3-1.98-2.13-3.33-4.07-3.02z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_right_arm_top",
      "fill": "#BC9555",
      "d": "M1019.4 313.8c-1.94.25-3.33 2.05-3.1 4.04l3.42 28.26c.24 1.98 2.02 3.4 3.97 3.15 1.94-.25 3.33-2.05 3.1-4.04l-3.43-28.25c-.23-1.98-2-3.4-3.96-3.15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_right_sleeve",
      "fill": "#D3A862",
      "d": "M1019.6 313.6c-2.64.32-4.58 2.68-4.4 5.4l.72 11.58 11.3-1.42-2.05-11.42c-.48-2.66-2.92-4.5-5.57-4.15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_right_shoe",
      "fill": "#91713D",
      "d": "M1020.76 433.52h-7.4V448h3.37c0-.55.3-.83.86-.83s.84.27.84.83h9.73c-.18-2.2-.8-3.55-1.9-4.06-2.96-1.4-4.6-3.08-4.96-4.46-.25-1.02-.44-3-.54-5.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_right_leg_bottom",
      "fill": "#BC9555",
      "d": "M1017.02 395.88c-1.97 0-3.56 1.6-3.56 3.56v34.08h7.12v-34.08c0-1.96-1.6-3.56-3.56-3.56z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl1_right_leg_top",
      "width": "7.12",
      "height": "56.94",
      "x": "1013.46",
      "y": "346.18",
      "fill": "#BC9555",
      "transform": "matrix(-1 0 0 1 2034.035 0)",
      "rx": "3.56"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_left_shoe",
      "fill": "#91713D",
      "d": "M1007.47 433.52h-7.4V448h3.37c0-.55.3-.83.86-.83.57 0 .86.27.85.83h9.73c-.18-2.2-.8-3.55-1.9-4.06-2.96-1.4-4.6-3.08-4.96-4.46-.26-1.02-.44-3-.55-5.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_left_leg_bottom",
      "fill": "#BC9555",
      "d": "M1003.73 395.88c-1.97 0-3.56 1.6-3.56 3.56v34.08h7.12v-34.08c0-1.96-1.6-3.56-3.57-3.56z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_left_leg_top",
      "fill": "#BC9555",
      "d": "M1003.73 346.18c-1.97 0-3.56 1.6-3.56 3.56v49.82c0 1.97 1.6 3.56 3.56 3.56 1.97 0 3.56-1.6 3.56-3.56v-49.82c0-1.97-1.6-3.56-3.57-3.56z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_skirt",
      "fill": "#91713D",
      "d": "M1020.58 346.18h-20.17c-3.94 4.77-7.1 16.5-9.5 35.22h39.17c-2.52-18.07-5.68-29.8-9.5-35.22z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_torso",
      "fill": "#D3A862",
      "d": "M1020.56 316.33c-3.57-6.6-16.24-6.47-20.17 0-2.63 4.3-4.6 14.28-5.92 29.92h31.8c-1.44-15.56-3.34-25.53-5.72-29.92z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_bag_2",
      "fill": "#FBD79E",
      "d": "M1005.22 312.4c-1.55 0-4.1.85-4.77 1.75 7.3 8.94 1.87 24.76-5.55 24.72-.1 1.04-.3 2.63-.36 3.6 17.73.36 16.74-22.98 10.68-30.07z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_bag_1",
      "fill": "#FBD79E",
      "d": "M1020.24 314.38c-.93-.72-2-1.42-3.83-1.98 4.4 7.5 7.6 17.14 8.92 25.1-.58-9.93-4.18-22.44-5.08-23.12z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "girl1_book_2",
      "fill": "#E2B56C",
      "points": "1011.6292 324.736312 1031.31564 321.565684 1035.76294 350.118549 1016.0765 353.289178",
      "transform": "matrix(-1 0 0 1 2047.392 0)"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "girl1_book_1",
      "fill": "#FBD79E",
      "points": "1006.3728 326.666607 1026.05924 323.495979 1030.06813 349.23413 1010.38169 352.404759",
      "transform": "matrix(-1 0 0 1 2036.44 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_left_hand",
      "fill": "#BC9555",
      "d": "M1021.52 340.88c1.02-.12 1.5-.9 2.64-1.7 1.32-.97 3.84-1.15 5.87-2.26.5.2-.25 1.83-1.07 2.24-.82.4-1.5.7-1.7.84-.2.13-.16.4.05.46.22.06 7.65-.53 8.03-.4.38.13.48 1.06.12 1.27-.35.2-6.2.8-6.36.9-.16.1-.06.3.03.38.1.1 6.33-.74 6.57-.63.25.12.3 1.1.13 1.22-.2.1-6.42.83-6.55.95-.13.12-.1.33.04.4.14.08 6.12-.82 6.4-.7.26.13.36 1.07.1 1.18-.24.12-6.26.97-6.34 1.07-.08.1-.06.22.03.3.1.07 4.62-.32 4.88-.2.26.12.4.82.1.96-.3.14-11.34.84-11.95.92-2.03.26-4.27-.73-4.52-3.2-.24-2.46 1.34-3.75 3.52-4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_left_arm_bottom",
      "fill": "#BC9555",
      "d": "M996.68 346.32c.14 2 1.84 3.5 3.8 3.36l25.56-1.82c1.96-.14 3.44-1.87 3.3-3.86-.13-2-1.83-3.5-3.8-3.36l-25.56 1.82c-1.96.14-3.44 1.87-3.3 3.86z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl1_left_arm_top",
      "width": "7.12",
      "height": "35.71",
      "x": "996.37",
      "y": "313.84",
      "fill": "#BC9555",
      "transform": "matrix(-1 0 0 1 1999.866 0)",
      "rx": "3.56"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_left_sleeve",
      "fill": "#D3A862",
      "d": "M1000.17 313.84c-2.66 0-4.87 2.08-5.02 4.74l-.67 11.67h11.4l-.7-11.67c-.14-2.66-2.35-4.74-5-4.74z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_neck",
      "fill": "#BC9555",
      "d": "M1013.93 308.52c-2.1-1.28-4.04-1.25-6.17 0 0 1.78.3 3.54-.95 4.35 1.85 2.93 6.23 3.04 8.08 0-.9-1.28-1.2-2.64-.95-4.35z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_face",
      "fill": "#BC9555",
      "d": "M1012.03 268.48c-16.5.1-16.76 9.88-16.6 18.34-8.04-.72-2.13 15.82 3.78 13.03.74 2.08 2.9 9.8 13.78 9.65 10.86-.13 14.55-12.35 14.7-20.75.17-8.4-2.5-20.34-15.65-20.27z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_mouth_bottom",
      "fill": "#A98448",
      "fill-rule": "nonzero",
      "d": "M1017.73 304.74c-.8.2-5.15.24-6.64-.06.05.38 2.34 1.44 4.26 1.44s2.4-.96 2.37-1.38z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_mouth_top",
      "fill": "#A98448",
      "fill-rule": "nonzero",
      "d": "M1018.2 304.68c0-.66-.25-1.45-2.84-1.45-1.8 0-4.73.9-6.17.48-.3-.1-.4.34 0 .5 1.83.65 3.4.48 6.16.48 1.8-.06 2.84 0 2.84 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_nose",
      "fill": "#A98448",
      "d": "M1016.2 290.53c-.24-1.03-3.3-1.14-3.32 0 0 1.14-.96 7.15 0 8.2.97 1.06 3.84.7 4.28 0 .43-.7-.7-7.17-.95-8.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl1_bangs",
      "fill": "#91713D",
      "d": "M1016.9 268.94c-16.6-4.16-23.48 6.3-25.6 15.44-2.14 9.15 1.37 13.45 7.1 13.52 5.74.07 5.53-6.9 6.18-6.76.63.15.6 5.3 7.1 5.3 6.52.03 6.75-4.05 7.6-4.33.86-.28 9.28 6.77 11.87-2.4 1.85-6.57-3.98-18.2-14.24-20.76z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48d72318","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_2/backgroundCharacters/girlOne.vue
// module id = 674
// module chunks = 1